// AgentCard — sidebar "Represented by" card on the player profile.
//
// Replaces the earlier inline RepresentedBy component in PlayerProfile.tsx.
// Identity only — agent name / photo / FIBA badge + a link to the public
// agent profile. M1 (PII) removed the raw Email + WhatsApp contact links;
// contact now routes through the hero's Express-interest / outreach flow, and
// the public /api/profile serializer no longer returns agent email/whatsapp.
// FIBA Licensed pill only renders when agents.is_fiba_licensed is true.

import { Link } from 'react-router-dom'
import FibaBadge from './FibaBadge'
import Avatar from '../Avatar'

interface AgentSummary {
  id: string
  slug: string | null
  name: string
  is_fiba_licensed: boolean
  fiba_license_number: string | null
  photo_url: string | null
  agency: { id: string; name: string; country: string | null } | null
}

export default function AgentCard({ agent }: { agent: AgentSummary }) {
  return (
    <section className="bg-hoop-surface border border-hoop-border rounded-2xl p-4">
      <h2 className="text-[11px] font-semibold uppercase tracking-wider text-hoop-accent mb-3">
        Represented by
      </h2>

      <div className="flex items-center gap-3 mb-3">
        <Avatar
          src={agent.photo_url}
          name={agent.name}
          className="w-9 h-9 rounded-full border border-hoop-border flex-shrink-0"
          textClassName="text-xs"
        />
        <div className="min-w-0">
          <div className="font-semibold text-sm text-hoop-text truncate">
            {agent.name}
          </div>
          {agent.agency && (
            <div className="text-xs text-hoop-text-3 truncate">
              {agent.agency.name}
            </div>
          )}
        </div>
      </div>

      <div className="mb-1">
        <FibaBadge licenseNumber={agent.fiba_license_number} />
      </div>

      {agent.slug && (
        <div className="mt-3 pt-3 border-t border-hoop-border">
          <Link
            to={`/agents/${agent.slug}`}
            className="text-xs text-hoop-text-3 hover:text-hoop-text"
          >
            View agent profile →
          </Link>
        </div>
      )}
    </section>
  )
}
